import React, { useState, useEffect, useCallback } from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { withRouter, useParams } from "react-router-dom";
import {
  createTeams,
  deleteTeam,
  getLearningNode,
  getlistClass,
} from "../../../../services/NexiDigitalAPI";
import Loading from "../../../../components/Loading";
import { BsPencilSquare, BsFillPeopleFill, BsListCheck, BsTrash } from "react-icons/bs";
import { GrAttachment } from "react-icons/gr";
import "./style.modules.scss";
import { CircularProgress } from "@material-ui/core";
import PreloaderBlur from "../../PreloaderBlur";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";
import SearchIcon from "@material-ui/icons/Search";
import {CustomDialog}  from "../../../../components/Dialogs";
import "./style.modules.scss";

const ListClass = (props) => {
  const { nodeCode, title } = useParams();

  const [nodeInfo, setNodeInfo] = useState(null);
  const [teamsList, setteamsList] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [alertshow, setAlert] = useState(0);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [teamToDelete, setTeamToDelete] = useState(null);

  const [pagination, setPagination] = useState({
    offset: 0,
    limit: 10,
  });
  const [totalRecords, setTotalRecords] = useState(9999);

  const [search, setSearch] = useState("");

  const paginationComponentOptions = {
    rowsPerPageText: "Usuários por página",
    rangeSeparatorText: "de",
  };

  function handleFilter() {
    const name = search ? { name: search } : {};

    setPagination({
      limit: pagination.limit,
      offset: 0,
      ...name,
    });
  }

  const onChangePage = (page) => {
    setPagination({
      ...pagination,
      offset: page === 1 ? 0 : (page - 1) * pagination.limit,
    });
  };

  const onChangeRowsPerPage = (limit, page) => {
    setPagination({
      ...pagination,
      limit,
      offset: page === 1 ? 0 : (page - 1) * limit,
    });
  };

  const newClassCreate = async () => {
    const contentDataNew = {
      name: null,
      description: "Descrição da turma",
      initialDate: null,
      finalDate: null,
      duration: 0,
      enrollments: 0,
      allowAccessUponCompletion: false,
      allowReenrollment: false,
      selfEnrollment: false,
      nodeCode,
    };

    setLoadingCreate(true);
    await createTeams({ data: contentDataNew })
      .then((response) => {
        const idTeam = response.data.idTeam;

        if (idTeam) {
          props.history.push(`/create-new-class/${nodeCode}/${title}/${idTeam}`);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoadingCreate(false);
      });
  };

  const editClassCreate = (d) => {
    props.history.push(`/create-new-class/${nodeCode}/${title}/${d.idTeam}`);
  };

  const statusStudents = (d) => {
    props.history.push(`/status-students/${nodeCode}/${title}/${d.idTeam}`);
  };

  const attendanceList = (d) => {
    props.history.push(`/attendance-list/${d.idTeam}/${title}`);
  };

  const attachUpload = (d) => {
    props.history.push(`/class-Attachment/${d.idTeam}/${d.name}/${title}`);
  };

  const columns = [
    {
      name: "Nome da turma",
      selector: "name",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
    {
      name: "Quantidade de usuário",
      selector: "enrollments",
      sortable: true,
    },
    {
      name: "Ações",
      sortable: false,
      selector: "null",
      cell: (d) => [
        <div key={d.idTeam} className="listBtn">
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip id={`tooltip-top`}> Editar turma </Tooltip>}
          >
            <button
              type="button"
              onClick={() => {
                editClassCreate(d);
              }}
            >
              <BsPencilSquare />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip id={`tooltip-top`}> Status dos alunos </Tooltip>}
          >
            <button
              type="button"
              onClick={() => {
                statusStudents(d);
              }}
            >
              <BsFillPeopleFill />
            </button>
          </OverlayTrigger>

          <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-top`}> Anexo </Tooltip>}>
            <button
              type="button"
              onClick={() => {
                attachUpload(d);
              }}
            >
              <GrAttachment />
            </button>
          </OverlayTrigger>

          {d.meetings.length > 0 && (
            <OverlayTrigger
              placement={"top"}
              overlay={<Tooltip id={`tooltip-top`}> Lista de presença </Tooltip>}
            >
              <button
                type="button"
                onClick={() => {
                  attendanceList(d);
                }}
              >
                <BsListCheck />
              </button>
            </OverlayTrigger>
          )}

          <OverlayTrigger
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-top`}>
                {d.enrollments > 0
                  ? "Não é possível excluir turma com usuários matriculados"
                  : "Excluir turma"}
              </Tooltip>
            }
          >
            <button
              type="button"
              onClick={() => d.enrollments === 0 && openDeleteModal(d)}
              disabled={d.enrollments > 0}
              style={{ opacity: d.enrollments > 0 ? 0.5 : 1 }}
            >
              <BsTrash />
            </button>
          </OverlayTrigger>
        </div>,
      ],
    },
  ];

  const listTeams = useCallback(async () => {
    const status = [
      { ref: "NOT_STARTED", text: "Não iniciada" },
      { ref: "STARTED", text: "Em andamento" },
      { ref: "FINISHED", text: "Concluída" },
    ];

    if (nodeInfo === null) {
      setNodeInfo((await getLearningNode(nodeCode, true)).data.result);
    }

    setIsLoaded(true);
    try {
      getlistClass({
        nodeCode: nodeCode,
        offset: pagination.offset,
        limit: pagination.limit,
        name: pagination.name,
      }).then((response) => {
        const containerApi = response.result;

        const containerFilterApi = containerApi.map((item) => {
          item.status = status.filter((st) => st.ref === item.status)[0].text;
          return item;
        });

        setTotalRecords(response.totalRecords);

        setteamsList(containerFilterApi);

        if (containerFilterApi.length > 0) {
          setAlert(1);
        }

        setIsLoaded(false);
      });
    } catch (e) {
    } finally {
      // setIsLoaded(false);
    }
  }, [nodeCode, pagination, nodeInfo]);

  const tableData = {
    columns: columns,
    data: teamsList,
  };

  useEffect(() => {
    listTeams();
  }, [listTeams]);

  const handleDeleteTeam = async () => {
    try {
      await deleteTeam(teamToDelete.idTeam);
      await listTeams();

      setShowDeleteModal(false);
      setTeamToDelete(null);
    } catch (error) {
      console.error("Erro ao excluir turma:", error);
    }
  };

  const openDeleteModal = (team) => {
    setTeamToDelete(team);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setTeamToDelete(null);
  };

  return (
    <div className="listClassBase">
      {(teamsList === null || isLoaded) && <PreloaderBlur />}

      <div className="header-title-wrapper">
        <div className="header-title">
          <button
            className="btnGoBack"
            onClick={() => {
              props.history.goBack();
            }}
          >
            <KeyboardArrowLeftIcon style={{ fontSize: 40 }} />
          </button>
          Gestão de Turmas - {nodeInfo?.title}
        </div>
      </div>

      <div className="post-form">
        <div className="content-page-form-group">
          <div className="content-page-card">
            <div
              style={{ backgroundColor: "#6b48ff" }}
              className="card-header template-card-header"
            >
              Lista de turmas
            </div>

            <div style={{ padding: "20px" }}>
              {nodeInfo?.status === "PUBLISHED" && (
                <>
                  <Button variant="success" onClick={newClassCreate}>
                    Criar Turma
                    {loadingCreate && (
                      <CircularProgress
                        className="content-page-button-icon ml-2"
                        size={16}
                        style={{ color: "white" }}
                      />
                    )}
                  </Button>
                </>
              )}
            </div>

            <div className="card-body card-title-body template-card-body">
              {alertshow === 1 && (
                <>
                  <div className="containerFilter">
                    <div className="containerFilterBuscar">
                      <input
                        type="text"
                        className="form-control input-default"
                        id="groupDetail"
                        style={{ marginRight: 8 }}
                        aria-describedby="usuario"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Procurar por nome"
                      />
                      <ButtonWithLoading
                        onClickHandler={handleFilter}
                        loading={isLoaded}
                        text={
                          <>
                            <SearchIcon style={{ height: 18 }} /> Pesquisar{" "}
                          </>
                        }
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <DataTableExtensions
                    filter={false}
                    // filterPlaceholder={"filtro"}
                    print={false}
                    {...tableData}
                    export={false}
                  >
                    <DataTable
                      columns={columns}
                      data={teamsList}
                      pagination
                      className={""}
                      progressComponent={
                        <Loading containerStyle={{ backgroundColor: "transparent" }} />
                      }
                      noHeader={true}
                      noDataComponent="Não foi encontrado nenhum dado"
                      onChangePage={onChangePage}
                      onChangeRowsPerPage={onChangeRowsPerPage}
                      paginationTotalRows={totalRecords}
                      paginationComponentOptions={paginationComponentOptions}
                      // progressPending={teamsList?.length === 0}
                      paginationServer
                      fixedHeader
                      highlightOnHover
                    />
                  </DataTableExtensions>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomDialog
        show={showDeleteModal}
        onClose={closeDeleteModal}
        onConfirm={handleDeleteTeam}
        title="Excluir turma?"
        description={`Tem certeza que deseja excluir a turma <strong>${teamToDelete?.name}</strong>? <span class="danger"><strong>Esta ação é irreversível.</strong></span>`}
        iconType="danger"
        buttons={[
          {
            label: "Excluir turma",
            onClick: handleDeleteTeam,
            variant: "danger"
          }
        ]}
      />
    </div>
  );
};

export default withRouter(ListClass);
